import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'app-nowform',
  templateUrl: './nowform.component.html',
  styleUrls: ['./nowform.component.css'],
  animations: [
    trigger('isVisible', [
      state('visible', style({
          opacity: '1'
      })),
      state('hidden', style({
          opacity: '0',
          display: 'none'
      })),
      transition('* => visible', [style({display: 'block'}), animate('500ms ease-out')]),
      transition('visible => hidden', [animate('500ms ease-out')])
    ])
  ]
})
export class NOWformComponent implements OnInit {
  hasdrop = new FormControl('false');
  oldRevenue = new FormControl(0.0);
  newRevenue = new FormControl(0.0);
  labourCosts = new FormControl(0.0);

  revenueDrop = 0;
  compensation = 0;
  deposit = 0;


  constructor() { }

  ngOnInit(): void {
    this.oldRevenue.valueChanges.subscribe(() => { this.update() });
    this.newRevenue.valueChanges.subscribe(() => { this.update() });
    this.labourCosts.valueChanges.subscribe(() => { this.update() });
  }

  update(): void {
    var newRevenue = parseFloat(this.newRevenue.value);
    var oldRevenue = parseFloat(this.oldRevenue.value);
    var labourCosts = 1.3 * parseFloat(this.labourCosts.value);

    this.revenueDrop = Math.abs((newRevenue - oldRevenue) / oldRevenue * 100);
    this.compensation = Math.abs(0.9 * this.revenueDrop) / 100 * labourCosts;
    this.deposit = Math.abs(0.8 * this.compensation);

    if (isNaN(this.revenueDrop)) { this.revenueDrop = 0 }
    if (isNaN(this.compensation)) { this.compensation = 0 }
    if (isNaN(this.deposit)) { this.deposit = 0 }
  }

  isNaN(val): boolean {
    return isNaN(val);
  }

  formatNumber(num) {
    return num.toString().replace('.', ',')
  }

  get inputCard() {
    if (this.hasdrop.value == 'true') {
      return "visible";
    }
    return "hidden";
  }

  get falseCard() {
    if(this.hasdrop.value == 'false' || this.revenueDrop < 20 || isNaN(this.revenueDrop) || this.compensation == 0 || this.deposit == 0){
      return "visible";
    }
    return "hidden";
  }

  get trueCard() {
    if(this.revenueDrop >= 20 && this.compensation != 0 && this.deposit != 0){
      return "visible";
    }
    return "hidden";
  }

}
